import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Link } from 'react-router-dom';
import Layout from '../layout';

import styles from '../styles/pages/coming-soon.scss';
import APP_ROUTES from '../../constants/app-routes';
import SignupPromotion from '../shared/signup-promotion';

import notFoundImage from '../../images/404-error.png';

class NotFound extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
        }
    }

    render() {
        return (
            <Layout>
                <div className={styles.comingContainer}>
                    <div style={{ paddingBottom: 45 }}>
                        <img
                            src={notFoundImage}
                            alt={this.props.intl.formatMessage({
                                id: 'not-found',
                                defaultMessage: 'Not',
                            })}
                            width="304"
                        />
                    </div>
                    <h1 className={styles.mainText} style={{ paddingBottom: 10 }}>
                        <FormattedMessage id="oops" defaultMessage="Ooops!" />
                    </h1>
                    <h1 className={styles.mainText} style={{ paddingBottom: 10 }}>
                        <FormattedMessage id="oops-text" defaultMessage="We can't seem to find the page you're looking for." />
                    </h1>
                    <h2 className={styles.secondaryText}>
                        <Link to={APP_ROUTES.mercadoUnicoProducts}>
                            <FormattedMessage id="coming-soon-button" defaultMessage="See Mercado Unico Products" />
                        </Link>
                    </h2>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(NotFound);



/** WEBPACK FOOTER **
 ** ./src/components/pages/not-found.jsx
 **/